module.exports = __webpack_public_path__ + "img/img11.8bdafd3a.png";